import { Classic } from "./InvitationThemes/Classic";
import { Modern } from "./InvitationThemes/Modern";
import { Photo } from "./InvitationThemes/Photo";


const InvitePreview = ({ inputData }) => {

    if (inputData.theme === "Classic") {
        return (<Classic inputData={inputData} />)
    }

    if (inputData.theme === "Modern") {
        return (<Modern inputData={inputData} />)
    }

    if (inputData.theme === "Photo") {
        return (<Photo inputData={inputData} />)
    }
}

export default InvitePreview;